/* eslint-disable class-methods-use-this */
import { getters, state } from '@/store/index';
import useStickyAlerts from '@/modules/alerts/composables/useStickyAlerts';
import StickyAlert from '@/modules/alerts/models/sticky-alert';
import { STICKY_ALERT_TYPE } from '@/modules/alerts/models/sticky-alert-type';
import BasicStickyAlertProps, {
  BASIC_STICKY_ALERT_TYPE,
} from '@/modules/alerts/models/basic-sticky-alert-props';

class RecaptchaService {
  constructor() {
    this.loaded = false;
    this.key = '';
  }

  configure() {
    this.key = getters.getRecaptchaKey(state);
  }

  isEnabled() {
    return !!this.key;
  }

  showBlockedAlert() {
    const { addAlert } = useStickyAlerts();
    const alert = new StickyAlert(
      STICKY_ALERT_TYPE.BASIC,
      new BasicStickyAlertProps(
        BASIC_STICKY_ALERT_TYPE.WARNING,
        'Security verification is currently unavailable',
        {
          subMessage:
            'Some features may not work properly. Please check your browser settings or ad blocker.',
          timeoutMs: 0,
        },
      ),
    );
    addAlert(alert);
  }

  load() {
    if (!this.loaded) {
      this.loaded = new Promise((resolve, reject) => {
        if (!this.key) {
          reject(new Error('No Recaptcha key'));
        }

        window.grecaptchaReadyCallback = () => {
          resolve();
        };

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.key}`;
        script.onerror = () => {
          const error = new Error('Failed to load reCAPTCHA script');
          this.showBlockedAlert();
          reject(error);
        };
        script.onload = () => {
          if (window.grecaptcha?.enterprise?.ready) {
            window.grecaptcha.enterprise.ready(() => {
              window.grecaptchaReadyCallback();
            });
          } else {
            this.showBlockedAlert();
            reject(new Error('reCAPTCHA not available'));
          }
        };
        document.body.appendChild(script);
      });
    }

    return this.loaded;
  }

  async execute(action) {
    if (!this.isEnabled()) {
      return Promise.resolve('');
    }

    try {
      this.load();
      return await window.grecaptcha.enterprise.execute(this.key, { action });
    } catch (error) {
      console.error('reCAPTCHA execute error:', error);
      return '';
    }
  }
}

export default new RecaptchaService();
